"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.receiveChangeProposalRequestSchema = void 0;
const zod_1 = require("zod");
const subjectField_schema_1 = require("../../../common/schemas/subjectField.schema");
const userWithUserId_schema_1 = require("../../../common/schemas/userWithUserId.schema");
const shortField_schema_1 = require("../../../common/schemas/shortField.schema");
const datetime_schema_1 = require("../../../common/schemas/datetime.schema");
const selectedItem_schema_1 = require("../../../common/schemas/selectedItem.schema");
const uniqueForIdValue_1 = require("../../../common/schemas/helpers/uniqueForIdValue");
const uniqueForCustomizableValue_1 = require("../../../common/schemas/helpers/uniqueForCustomizableValue");
const Reason_1 = require("../../types/Reason");
const selectedItemWithSpecificTypeOrCustomName_schema_1 = require("../../../common/schemas/selectedItemWithSpecificTypeOrCustomName.schema");
const Keyword_1 = require("../../types/Keyword");
const attachments_schema_1 = require("../../../common/schemas/attachments.schema");
const amountWithCurrency_schema_1 = require("../common/amountWithCurrency.schema");
const Purpose_1 = require("../../types/Purpose");
const contact_schema_1 = require("../../../common/schemas/contact.schema");
exports.receiveChangeProposalRequestSchema = zod_1.z
    .object({
    subject: subjectField_schema_1.subjectFieldSchema,
    from: contact_schema_1.contactSchema,
    to: userWithUserId_schema_1.userWithUserIdSchema.array().nonempty(),
    senderNumber: shortField_schema_1.shortFieldSchema.optional(),
    description: zod_1.z.string().optional().nullable(),
    dueDate: datetime_schema_1.datetimeSchema.optional().nullable(),
    number: shortField_schema_1.shortFieldSchema.optional().nullable(),
    reasons: (0, selectedItem_schema_1.selectedItemWithSpecificTypeSchema)(Reason_1.Reason)
        .array()
        .optional()
        .refine(...(0, uniqueForIdValue_1.uniqueForIdValue)(uniqueForCustomizableValue_1.uniqueReasonsMessage)),
    disciplines: selectedItem_schema_1.selectedItemSchema
        .array()
        .optional()
        .refine(...(0, uniqueForIdValue_1.uniqueForIdValue)(uniqueForCustomizableValue_1.uniqueDisciplinesMessage)),
    keywords: (0, selectedItemWithSpecificTypeOrCustomName_schema_1.selectedItemWithSpecificTypeOrCustomNameSchema)(Keyword_1.Keyword)
        .array()
        .optional()
        .refine(...(0, uniqueForCustomizableValue_1.uniqueForCustomizableValue)(uniqueForCustomizableValue_1.uniqueKeywordsMessage)),
    proposedTotalAmount: amountWithCurrency_schema_1.amountWithCurrencySchema.optional().nullable(),
    proposedTotalDays: zod_1.z.number().nonnegative().int().optional().nullable(),
    purpose: (0, selectedItem_schema_1.selectedItemWithSpecificTypeSchema)(Purpose_1.Purpose, [
        Purpose_1.Purpose.ForConstruction,
        Purpose_1.Purpose.ForInformationOnly,
        Purpose_1.Purpose.ForReview,
        Purpose_1.Purpose.Other,
        Purpose_1.Purpose.Recommendation,
    ]),
    attachments: attachments_schema_1.optionalAttachmentsSchema,
    version: zod_1.z.string(),
})
    .strict();
//# sourceMappingURL=receiveChangeProposalRequest.schema.js.map